import type { PblCitizenEvaluationPayload } from '@/types/pbl';

export type OverallRating = 1 | 2 | 3 | 4 | 5;

export type CitizenCaseFeedbackForm = {
  rating?: OverallRating;
  platform_feedback: string;
  helpful_tools: string;
  other_legal_areas: string;
};

export const optionalFeedbackFields = ['platform_feedback', 'helpful_tools', 'other_legal_areas'] as const;

export const buildCitizenFeedbackPayload = (
  form: CitizenCaseFeedbackForm & { rating: OverallRating }
): PblCitizenEvaluationPayload => {
  const payload = Object.fromEntries(
    optionalFeedbackFields
      .map((field) => [field, form[field].trim()] as const)
      .filter(([, value]) => value.length > 0)
  );

  return {
    evaluator_role: 'citizen',
    rating: form.rating,
    ...(Object.keys(payload).length ? { payload } : {}),
  };
};
